import { Point2d } from '../../../../../viewer/utilities/math-helpers';

/**
 * How far right of the icon (pixels), and how far from the top of the screen, the dialog opens.
 */
const iconOffset = 16;
const top = 80;

/**
 * Gets where a dialog of an asset, opened from an icon of the asset, opens: beside the icon that
 * was clicked, so that it is next to the asset menu, near the top of the screen. The dialog is kept
 * within the screen.
 */
export const getAssetDialogPosition = (iconPos?: Point2d) =>
  iconPos ? { left: iconPos.x + iconOffset, top } : ('center' as const);

/**
 * How far (pixels) right of the asset menu, and below its top, a dialog opens beside it.
 */
const assetMenuGap = 8;

/**
 * Gets where a dialog of an asset opens when no icon was clicked, e.g. when the asset is selected:
 * just right of the asset menu, aligned with its top. The dialogs that open there dock below each
 * other, see Props.autoDock of Dialog.
 */
export const getBesideAssetMenuPosition = () => {
  const menu = document.querySelector('[data-asset-menu-root="true"]');

  if (!menu) {
    return 'center' as const;
  }

  const { right, top } = menu.getBoundingClientRect();
  return { left: right + assetMenuGap, top: top + assetMenuGap };
};
